import React, { Component } from "react";
import TrackHomeListContainer from "../../Containers/TrackHomeListContainer";
import TrackRecentContainer from "../../Containers/TrackRecentContainer";
import TrackHomeList from "./TrackHomeList";
import MediaProvider from "~/Components/library/MediaProvider";
import TracksRecent from "./TracksRecent";
import FeaturedPromoMixes from "./FeaturedCurrentPromos";
import Kba from "../../Components/Elements/Kba";

/// @TODO get the date from the rewind

class HomeRewindPage extends Component {
  render() {
    return (
      <MediaProvider>
        <div className="home-page-component">
          <div className="home-component">
            <TrackHomeListContainer days={parseInt(this.props.match.params.days, 10)} render={(props) => <TrackHomeList {...props} />} />
            <Kba />
            <FeaturedPromoMixes />
            <TrackRecentContainer
              render={(props) => {
                return <TracksRecent {...props} />;
              }}
            />
          </div>
        </div>
      </MediaProvider>
    );
  }
}

export default HomeRewindPage;
